import rem from "polished/lib/helpers/rem";
export var sizes = {
    body1: 20,
    body2: 16,
    label: 14,
};
var baseFontSize = 16;
export var fontSizes = Object.keys(sizes).reduce(function (fonts, size) {
    var token = sizes[size];
    var remSize = rem(token, baseFontSize);
    fonts[size] = remSize;
    return fonts;
}, {});
